export const exportHeaderOrder = [
	'qualificationYear',
	'type',
	'markingTeamId',
	'markingTeamTitle',
	'markingTeamCode',
	'markingMethodCurrentYear',
	'templateName',
	'markingFee1',
	'appointeeId',
	'appointeeTitle',
	'appointeeInitials',
	'appointeeSurname',
	'appointeeNiNo',
	'markerCode',
	'apptId',
	'meetingAttendReq',
	'markingTeamMinScripts',
	'markingTeamMaxScripts'
];

export const headerKeyNames = {
	A1: 'Qual Year',
	B1: 'Appointment Type',
	C1: 'Marking Team ID',
	D1: 'Marking Team Title',
	E1: 'Marking Team Code',
	F1: 'Marking Method',
	G1: 'Template Name',
	H1: 'Marking Fee',
	I1: 'Appointee ID',
	J1: 'Appointee Title',
	K1: 'Appointee Initials',
	L1: 'Appointee Surname',
	M1: 'Appointee NiNo',
	N1: 'Marker Code',
	O1: 'Appointment ID',
	P1: 'Meeting Attendence',
	Q1: 'Min Scripts',
	R1: 'Max Scripts'
};

export const validationLabels = {
	contract_mgmt: 'Contract Management',
	contract_fees: 'Contract Fees',
	spare_fields: 'Contract Spare Fields',
	script_alloc: 'Script Allocation',
	script_dates: 'Delivery & Return Dates',
	meetings_mar: 'Marker Meetings'
};
